import React, { useState, useEffect, useRef, useContext } from "react";
import Button from "./Button";
import Pager from "./Pager";
import Navbar from "./Navbar";
import { useFormCtx } from "../FormContext";
import Transition from "./Transition";
import AniamtedFadeBlock from "./AniamtedFadeBlock";
import * as Const from "./../_Const";
import useMediaQuery from "../hooks/useMediaQuery";
import useDarkMode from "../hooks/useDarkMode";

const PageWrapper = ({ title, index, children, showAppInfo, showTitle = true, animate = true, showNext = true, showSkip = false, skipText = "" }) => {
  const [showShadow, setShowShadow] = useState(true);
  const { validate, getPageData, stepCount, navigateBackButtons, showBackButton, isDebugMode } = useFormCtx();
  const page = getPageData(index);
  const animateInit = animate ? "initial" : false;

  const nextBtnPlaceCss = "justify-self-center"; //Const.isTerminal() ? "justify-self-end" : "justify-self-center";

  const showFooter = page.showNext || showBackButton() ? true : false;
  const mtH1 = page.showSteps ? "mt-4" : "mt-8";
  const [isDarkMode] = useDarkMode();
  const image = isDarkMode ? "/img/logo_cekarnavmobilu_dark.png" : "/img/logo_cekarnavmobilu.png";

  const isTerminal = Const.isTerminal();
  function getEnv() {
    let env = "";
    let url = window?.location?.origin;
    //url = "https://testterminal.cekarnavmobilu.cz/";
    if (isDebugMode) {
      if (isTerminal) {
        env = " " + Const.ENV + " - TERMINAL - URL: " + url + " - API: " + Const.API_URL;
      } else {
        env = " " + Const.ENV + " - MOBILE - " + url + " API: " + Const.API_URL;
      }
    } else {
      if (!Const.isProduction()) {
        if (isTerminal) {
          env = " " + Const.ENV + " - TERMINAL";
        } else {
          env = " " + Const.ENV + " - MOBILE";
        }
      }
    }

    return env;
  }

  return (
    <div className="flex flex-col h-dvh overflow-hidden">
      {/* <header class="w-full text-center border-b border-grey p-4">Some header</header> */}
      <div className="flex-1 overflow-y-scroll pb-6">
        <Navbar />
        <div className="container mx-auto overflow-x-hidden">
          {page.showSteps && (
            <div className="mt-8 mx-6">
              <Pager step={page.stepIndex} stepCount={stepCount} />
            </div>
          )}
          <Transition initial={animateInit}>
            {showTitle && <h1 className={`text-3xl text-accent-dark dark:text-accent mx-6 ${mtH1}`}>{title}</h1>}
            {children}
          </Transition>
        </div>
      </div>
      {showFooter && !isTerminal && (
        <footer className={`w-full  ${showShadow && `shadow-[0_1px_17px_5px_rgba(190,228,224,1)]`}`}>
          <div className="grid grid-cols-[1fr_2fr] justify-items-stretch mx-6 mb-4 mt-4">
            {/* kvuly spravnemu zarovnani css next tlacitka v pravo bude {page.showBack && uvnitr */}
            <div className="">{showBackButton() && <Button title="zpět" className={"shadow-md"} type="back" onClick={navigateBackButtons} place="left" />}</div>

            {page.showNext && (
              <div className={`col-span-3 ${nextBtnPlaceCss}`}>
                <Button type="primary" className={"shadow-md"} title={page.nextTitle} showIcon={page.showNextIcon} onClick={() => validate(index)} />
              </div>
            )}
          </div>
        </footer>
      )}
      {showFooter && isTerminal && (
        <footer className="">
          <div className="grid">
            {showNext && page.showNext && (
              <div className={`col-span-3 w-full ${nextBtnPlaceCss}`}>
                <Button
                  type="terminal"
                  className={"w-full h-20 rounded-none text-3xl"}
                  title={page.nextTitle}
                  showIcon={page.showNextIcon}
                  onClick={() => validate(index)}
                />
              </div>
            )}

            {showSkip && page.showNext && (
              <div className={`col-span-3 w-full ${nextBtnPlaceCss}`}>
                <Button
                  type="terminal-error"
                  className={"w-full h-20 rounded-none text-3xl"}
                  title={skipText}
                  showIcon={page.showNextIcon}
                  onClick={() => validate(index, true)}
                />
              </div>
            )}
          </div>
        </footer>
      )}
      {showAppInfo && (
        <footer className="w-full">
          <AniamtedFadeBlock>
            <div className="grid grid-cols-[1fr_2fr]  justify-items-stretch mx-6 mb-0 mt-0">
              <div className="text-accent-dark font-black text-xs inline-flex">
                {isTerminal && (
                  <div className="ml-1">
                    <img src={image} width={125} />
                  </div>
                )}
                {!isTerminal && (
                  <a href="https://cekarnavmobilu.cz/" className="ml-1">
                    <img src={image} width={125} />
                  </a>
                )}
              </div>
              <div className="text-secondary font-light text-xs justify-self-end">
                verze: {process.env.REACT_APP_VERSION}
                {getEnv()}
              </div>
            </div>
          </AniamtedFadeBlock>
        </footer>
      )}
    </div>
  );
};

export default PageWrapper;
